import { isString } from "lodash";
import { Filters, Value } from "PFTypes";

import { WorkOpportunitiesTab } from "../constants";

// It was Deloitte request to automatically change the order to "Most Relevant" when we search with term.
// To make it work, we clear the order and the default one that comes from API is set.
// We don't have "Most Relevant" order before searching by term.

export const handleTermOrderClear = (
  oldFilters: Filters<Value>,
  newFiltersOrValue: Value | Filters<Value>,
  clearOrder: VoidFunction,
  tab: WorkOpportunitiesTab | null
): void => {
  if (tab !== WorkOpportunitiesTab.MatchingRoles) {
    return;
  }

  const newValue = isString(newFiltersOrValue) ? (newFiltersOrValue as Value) : undefined;
  const newFilters = newFiltersOrValue as Filters<Value> | undefined;

  const oldTermValue = oldFilters.fields?.term;
  const newTermValue = newValue ?? newFilters?.fields?.term;

  if (!!newTermValue && newTermValue !== oldTermValue) {
    clearOrder();
  }
};
